export default {
    'about': {
        'about': 'O nas',
        'crew': 'Ekipa Radia1.7',
        'editorial-college': 'Kolegium redaktorskie',
        'how-to-listen': 'Jak nas słuchać',
        'our-history': 'Nasza historia',
        'who-we-are': 'Kim jesteśmy'
    },
    'blog': {
        blog: 'Blog muzyczny',
        categories: 'Kategorie',
        newest: 'Najnowsze'
    },
    'breadcrumbs': {
        'author': 'Autor',
        'calendar': 'Kalendarium',
        'posts': 'Wpisy',
        'posts-from-day': 'Wpisy z dnia',
        'tags': 'Tagi'
    },
    'contact': {
        'contact': 'Kontakt',
        'contact-with-us': 'Skontaktuj się z nami',
        'cooperation': 'Współpraca',
        'recruitment': 'Rekrutacja'
    },
    'news': 'Aktualności',
    'offer': {
        'downloads': 'Do pobrania',
        'offer': 'Oferta',
        'services': 'Nasze usługi',
        'voice-bank': 'Bank głosów'
    },
    'podcasts': 'Podcasty',
    'posts': {
        calendar: 'Kalendarium wpisów'
    },
    'search-results': 'Wyniki wyszukiwania',
    'schedule': {
        'hot-17': 'Gorąca 17',
        'schedule': 'Ramówka',
        'what-we-play': 'Co gramy'
    }
}
